"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressRingArgTypes = void 0;
exports.ProgressRingArgTypes = {
  currentBalance: {
    name: 'Current Balance',
    control: {
      type: 'number'
    },
    description: 'Current balance to display on the Progress Ring'
  },
  targetBalance: {
    name: 'Target Balance',
    control: {
      type: 'number'
    },
    description: 'Target balance to complete the circle on the Progress Ring'
  },
  size: {
    name: 'Size',
    options: ['small', 'medium', 'large'],
    control: {
      type: 'select'
    },
    description: 'Size of the Progress Ring component'
  },
  variant: {
    name: 'Variant',
    options: ['default', 'points', 'gold', 'secondary', 'alert'],
    control: {
      type: 'select'
    },
    description: 'Variant of the Progress Ring component'
  },
  balancePrefix: {
    name: 'Balance Prefix',
    control: {
      type: 'text'
    },
    description: 'Prefix to display on the balance'
  },
  balanceDescriptor: {
    name: 'Balance Descriptor',
    control: {
      type: 'text'
    },
    description: 'Descriptor to display on the balance'
  },
  animateLoading: {
    name: 'Animate Loading',
    control: {
      type: 'boolean'
    },
    description: 'Display an animation of the progress loading on the ring'
  }
};
